import React from 'react';
import styled from 'styled-components';

const LayoutStylesContainer = styled.div`
    .page-container {
        padding-top: 70px;
        padding-bottom: 70px;
    }

    .nav-pad {
        padding-top: 76px;
    }

    button {
        &:hover {
            cursor: pointer;
        }
    }
`;

const LayoutStyles = ({ children }) => {
    return (
        <LayoutStylesContainer>
            <div className="nav-pad">{children}</div>
        </LayoutStylesContainer>
    );
};

export default LayoutStyles;
